import { PageContainer } from '@/shared/ui';

import { ImportPanel } from '../components/ImportPanel';

/**
 * Standalone bulk-catalog-import page (`/catalog/import`).
 *
 * Shares its body with the {@link ImportPanel} that also powers the import
 * slideout on the Products workspace — same form, two entry points.
 */
export function ImportPage() {
  return (
    <PageContainer
      title="Импорт каталога"
      subtitle="Массовая загрузка товаров и категорий из Excel-файла или Google-таблицы."
      maxWidth={900}
    >
      <ImportPanel />
    </PageContainer>
  );
}
